import { MemberAccessLevel } from "../features/Settings/constant.ts";

export const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const mtw_companies = [
  "mtw",
  "hungama",
  "excedor",
  "loginext",
  "veefly",
  "select-ai",
  "rebel-foods",
  "shaadi",
  "fractal",
  "pepperfry",
  "npci",
  "idfc",
  "nazara",
  "pixeldust",
  "quantiphi",
  "flexiloans",
  "drip-capital",
  "rezolv",
  "tss",
  "fancode",
  "upliance",
  "pitch-perfekt",
];

export enum CandidateClass {
  SHORTLISTED = "curated",
  OTHER = "other",
  UNQUALIFIED = "unqualified",
}

export enum ShortlistedCandidateState {
  Selected = "E",
  Rejected = "B",
  Scheduled = "S",
  NeedsApproval = "H",
  Save = "SAVE",
  All = "A",
}

export const StateMap = {
  InviteSent: "InviteSent",
  PreInvite: "PreInvite",
  Interviewed: "Interviewed",
  Others: "Others",
  Unqualified: "Unqualified",
  NotResume: "NotResume",
  Curated: "Curated",
  Rejected: "Rejected",
  All: "All",
} as const;

export const WebStates: String[] = [
  StateMap.All,
  StateMap.Curated,
  StateMap.InviteSent,
  StateMap.PreInvite,
  StateMap.Interviewed,
  StateMap.Others,
  StateMap.Unqualified,
  StateMap.Rejected,
];
export const PhoneStates: String[] = [
  StateMap.All,
  StateMap.Curated,
  StateMap.Interviewed,
  StateMap.InviteSent,
  StateMap.Others,
  StateMap.Unqualified,
  StateMap.Rejected,
];

export const CandidateState = {
  // Shortlisted: "R,G,C",
  All: "",
  InviteSent: "S,A,T",
  Curated: "D,H",
  PreInvite: "PI",
  Interviewed: "C",
  Others: "M,U,P,F",
  Unqualified: "Z,Y",
  Rejected: "W,X",
  NotResume: "N",
};
export const PhoneCandidateState = {
  All: "",
  Curated: "N,H",
  // Scheduled, InProgress,
  InviteSent: "I,P",
  // Completed, Incomplete
  Interviewed: "C,L",
  // NotInterested, Unreachable, NoAnswer, Invalid
  Others: "M,U,S,Y,X",
  // Unqualified
  Unqualified: "Z",
};

export enum buttonStatusEnum {
  DEFAULT = "DEFAULT",
  CONFIRM = "CONFIRM",
  LOADING = "LOADING",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}

export const CandidateStateTag = {
  P: "Parsed Only",
  A: "Waiting for Approval",
  M: "Not Interested",
  U: "Unreachable",
};

export const chartData = ["OVERALL", "SKILL", "CV"];

export enum CandidateRating {
  "GREAT" = "R",
  "GOOD" = "G",
  "CV" = "C",
}
export const CandidateRatingMap = {
  R: "GREAT",
  G: "GOOD",
  C: "CV",
  A: "ALL_MATCH",
};

export const NoticePeriodOptions = {
  IMMEDIATE: "Immediate",
  WITHIN_MONTH: "Within 1 Month",
  WITHIN_2MONTHS: "Within 2 Months",
  MORE_THAN_2MONTHS: "More than 2 Months",
};

export enum KeyTitleMap {
  "availability" = "Availability",
  "educational_level" = "Level of Education",
  "educational_list" = "Education List",
  "years_of_experience" = "Years of Experience",
  "years_of_experience_tag" = "Years of Experience",
  "expected_salary" = "Expected Salary",
  "salary_enum" = "Salary",
  "english_quality" = "English Proficiency",
  "confidence" = "Confidence",
  "professional_level" = "Professional Level",
  "professional_list" = "List of Profession",
  "assessment_score" = "Assessment Score",
  "AI_skill_score" = "Skill Score",
}

export enum ConfigUpdateEnum {
  SKILL_UPDATE = "SU",
  SKILL_DELETE = "SD",
  Base_Dialog_DELETE = "BD",
  Base_Dialog_ADD = "BA",
  SKILL_ADDED = "SA",
  SKILL_ADD_MORE_QUESTIONS = "SM",
  SPECIALIZED_EDUCATION = "SE",
  DOMAIN_EXPERIENCE = "DE",
  LOCATION_UPDATED = "LU",
  ORDER_UPDATE = "OU",
  AVAILABILTY_UPDATED = "AU",
  SALARY_UPDATED = "SL",
  ADDITIONAL_LOGISTIC_QUESTION = "AL",
  ADDITIONAL_ROLE_BASED_QUESTION = "AR",
  CUSTOM_MCQ_ADDED = "MA",
  SKLL_QUESTION_COUNT_UPDATE = "SQ",
  SKILL_PRIORITY_UPDATE = "PU",
  REGION_UPDATE = "RU",
  // Designer MCQ bank: hand-pick the questions asked for a topic
  // (update_json = question ids; [] restores the random sample).
  MCQ_QUESTION_SELECT = "MS",
  // Designer MCQ timer: timer_mode / total_time / time_per_question.
  MCQ_TIMER_UPDATE = "MT",
}

export enum CandidatePageType {
  PAGE = "PAGE",
  PUBLIC = "PUBLIC",
  PDF = "PDF",
}

export enum Layout {
  div = "div",
  section = "section",
  li = "li",
}

export enum Currency {
  INR = "₹",
  USD = "$",
}

// One selectable "Admin" — level B (CHRO + HR, full access). Level C
// (CHRO-only) is legacy: still displayed for members who hold it (see
// memberLevelLabels) but no longer offered when assigning roles.
export const accessLevelOptions = [
  { label: MemberAccessLevel.HR, id: "H" },
  { label: MemberAccessLevel.HM, id: "M" },
  { label: MemberAccessLevel.Admin, id: "B" },
];

// Display labels for every level a member can hold, including legacy ones.
export const memberLevelLabels: Record<string, string> = {
  H: MemberAccessLevel.HR,
  M: MemberAccessLevel.HM,
  B: MemberAccessLevel.Admin,
  C: MemberAccessLevel.Admin,
  A: "Account Manager",
};

export enum AccessLevel {
  HR = "HR",
  HM = "HM",
  ADMIN = "Admin",
}

export const AnalyticTabKeys = [
  { label: "This Month", value: "this_month" },
  { label: "Last Month", value: "last_month" },
  { label: "Lifetime", value: "lifetime" },
];

export const GetKnit_ATS_LIST = {
  greenhouse: "Greenhouse",
  "darwinbox-ats": "Darwinbox",
  lever: "Lever",
  "workday-ats": "Workday",
  "successfactors-ats": "SAP SuccessFactors",
  "oracle-hcm-ats": "Oracle Cloud HCM",
  "smartrecruiters-ats": "SmartRecruiters",
  workable: "Workable",
  teamtailor: "TeamTailor",
  breezy: "Breezy",
  "sage-ats": "Sage Recruitment",
  "adp-workforcenow-ats": "ADP Workforce Now",
  bullhorn: "Bullhorn",
  ashby: "Ashby",
  "ukgpro-ats": "UKG Pro Recruiting",
  "keka-ats": "Keka ATS",
  "zoho-recruit": "Zoho Recruit",
  "bamboohr-ats": "BambooHR ATS",
  "jazzhr-ats": "JazzHR ATS",
  "knit-playground-ats": "Knit Playground ATS",
};

export const interviewLanguageOptions = [
  { value: "English", disabled_web: false, disabled_phone: false , id: "En"},
  { value: "Hindi", disabled_web: false, disabled_phone: false , id: "Hi"},
  { value: "Tamil", disabled_web: false, disabled_phone: false, isNew: true , id: "Ta"},
  { value: "Telugu", disabled_web: false, disabled_phone: false, isNew: true , id: "Te"},
  { value: "Marathi", disabled_web: false, disabled_phone: false, isNew: true , id: "Mr"},
  { value: "Gujarati", disabled_web: true, disabled_phone: false, isNew: true , id: "Gu"},
  { value: "Spanish", disabled_web: true, disabled_phone: true , id: "Es"},
  { value: "Bengali", disabled_web: true, disabled_phone: true , id: "Bn"},
  { value: "Kannada", disabled_web: true, disabled_phone: true , id: "Kn"},
  { value: "French", disabled_web: true, disabled_phone: true , id: "Fr"},
  { value: "German", disabled_web: true, disabled_phone: true , id: "De"},
];

export enum ReportIssuesEnum {
  MISUNDERSTOOD_CANDIDATE_RESPONSES = "M",
  INCORRECT_CANDIDATE_INFORMATION = "C",
  INCORRECT_TRANSCRIPTION = "T",
  POOR_AUDIO_QUALITY = "A",
  INTERVIEW_INCOMPLETE = "I",
  SCORED_INCORRECTLY = "S",
  PRODUCT_ENHANCEMENT = "E",
  OTHER = "O",
}

export const ReportIssueLabels = {
  MISUNDERSTOOD_CANDIDATE_RESPONSES: "Misunderstood Candidate Responses",
  INCORRECT_CANDIDATE_INFORMATION: "Incorrect Candidate Information",
  INCORRECT_TRANSCRIPTION: "Incorrect Transcription",
  POOR_AUDIO_QUALITY: "Poor Audio Quality",
  INTERVIEW_INCOMPLETE: "Interview Incomplete",
  SCORED_INCORRECTLY: "Scored Incorrectly",
  PRODUCT_ENHANCEMENT: "Product Enhancement",
  OTHER: "Other",
};

export const StageWiseColor = {
  ENGAGED: "#fe9321",
  SCREENED: "#4ae5ab",
  INTERVIEWED: "#c8db2a",
  CALLED: "#8d80ff",
  CURATED: "#ef4687",
  NO_REVIEW: "#0891b2",
  SELECTED: "#00ff00",
  REJECTED: "#ff0000",
};

export enum ActivityLogActionType {
  INTERVIEW_VIEWED_BY_COMPANY_USER = "IV",
  RECORDING_PLAYED_BY_COMPANY_USER = "RP",
  WHATSAPP_MESSAGE_SENT_BY_COMPANY_USER = "WS",
  INTERVIEW_PROFILE_DOWNLOADED = "ID",
  CURATED_BY_COMPANY_USER = "CC",
  CURATED_BY_BABBLEBOTS = "CB",
  SELECTED_BY_COMPANY_USER = "SC",
  REJECTED_BY_COMPANY_USER = "RC",
  PROFILE_SHARED_BY_COMPANY_USER = "PS",
}

export const ActivityLogActionLabelMap: Record<ActivityLogActionType, string> =
  {
    [ActivityLogActionType.INTERVIEW_VIEWED_BY_COMPANY_USER]: "Profile viewed",
    [ActivityLogActionType.RECORDING_PLAYED_BY_COMPANY_USER]:
      "Recording played",
    [ActivityLogActionType.WHATSAPP_MESSAGE_SENT_BY_COMPANY_USER]:
      "WhatsApp message sent",
    [ActivityLogActionType.INTERVIEW_PROFILE_DOWNLOADED]: "Profile downloaded",
    [ActivityLogActionType.CURATED_BY_COMPANY_USER]: "Curated by company",
    [ActivityLogActionType.CURATED_BY_BABBLEBOTS]: "Curated by BabbleBots",
    [ActivityLogActionType.SELECTED_BY_COMPANY_USER]: "Selected",
    [ActivityLogActionType.REJECTED_BY_COMPANY_USER]: "Rejected",
    [ActivityLogActionType.PROFILE_SHARED_BY_COMPANY_USER]: "Profile shared",
  };

export const AssessmentTypeRouteMap: Record<string, string> = {
  interviewtype: "web",
  phoneinterviewtype: "phone",
  test: "coding",
};

export const PhonePlaygroundStage = {
  Start: "P",
  Calling: "S",
  Evaluating: "E",
  Done: "D",
};

export enum DesignPath {
  JD_CONVERSATION = "jd_conversation",
  CODING = "coding_test",
}

export enum RadioGroupDirection {
  Vertical = "vertical",
  Horizontal = "horizontal",
}
